export const blogs = [
  {
    title: "How well do you know your eggs?",
    preview:
      "Did you know? According to Healthline.com that Egg color depends on the breed of the chicken. For example, White Leghorn chickens lay white-shelled eggs, while Plymouth Rocks and Rhode Island Reds lay brown-shelled eggs. Several studies have found that shell color has no significant effect on egg quality and composition",
    thumbnail:
      "https://images.unsplash.com/photo-1582722872445-44dc5f7e3c8f?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=2850&q=80",
    path: "egg-blog",
  },
];
